import * as R from 'ramda';
import type { OutcropPaleogeographyPartsFragment } from '~/apollo/generated/v4/graphql';
import { cn } from '~/utils/common';
import { PaleoMapPictureModal } from './paleomap-picture-modal';

export function PaleomapListItem({
  outcropId,
  paleoMap,
}: {
  outcropId: number;
  paleoMap: OutcropPaleogeographyPartsFragment['paleoMaps'][number];
}) {
  if (!paleoMap.pictures || !paleoMap.pictures.length) return null;

  const pictures = paleoMap.pictures
    .slice()
    .sort(R.ascend(p => p.priority ?? Infinity));

  // 2 pictures uploaded gives a 2-column layout
  // 3 pictures uploaded gives a 3- column layout
  // all other amounts will have one picture per column (usually just one picture is uploaded in this case)
  // NB: It is possible to upload more than 3 pictures, but they will not be shown

  const picture0 = pictures.at(0);
  const picture1 = pictures.at(1);
  const picture2 = pictures.at(2);

  const isTwoColumnLayout = pictures.length === 2;
  const isThreeColumnLayout = pictures.length === 3;
  const isOneColumnLayout = pictures.length !== 2 && pictures.length !== 3;

  return (
    <div className="grid lg:grid-cols-12 gap-6">
      <div
        className={cn({
          'lg:col-span-6': pictures.length === 2,
          'lg:col-span-4': pictures.length >= 3,
          'lg:col-span-12': ![2, 3].includes(pictures.length),
        })}
      >
        {picture0 && (
          <PaleoMapPictureModal
            outcropId={outcropId}
            paleoMapId={parseInt(paleoMap.id)}
            picture={picture0}
          />
        )}
        {picture2 && (
          <PaleoMapPictureModal
            outcropId={outcropId}
            paleoMapId={parseInt(paleoMap.id)}
            picture={picture2}
          />
        )}
      </div>

      <div
        className={cn({
          'lg:col-span-6': isTwoColumnLayout,
          'lg:col-span-8': isThreeColumnLayout,
          'lg:col-span-12': isOneColumnLayout,
        })}
      >
        {picture1 && (
          <PaleoMapPictureModal
            outcropId={outcropId}
            paleoMapId={parseInt(paleoMap.id)}
            picture={picture1}
          />
        )}
      </div>
    </div>
  );
}
